import { isValidPhoneNumber } from 'libphonenumber-js';
import { englishValidationMessages } from './messages';
import { getRequiredValidator } from './required';
export const getPhoneNumberError = (valueName)=>englishValidationMessages.invalid({
        field: valueName
    });
export const usPhoneNumberError = englishValidationMessages.invalidUsPhone();
const validUSPhoneRegex = new RegExp(/^\+1\d{10}$/);
export const makePhoneNumberValidators = (messages)=>{
    /** true means there's no error. false means there's an error. string means there's an error and gives the error-message. */ const getPhoneNumberValidator = function getPhoneNumberValidator() {
        let valueName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : messages.fieldNames.phoneNumber, required = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return (value)=>{
            const requiredError = getRequiredValidator(required)(value);
            if (requiredError !== true) {
                return requiredError;
            }
            const isEmptyPhoneNumber = !value || value === '';
            const hasSpaces = typeof value === 'string' && value.split('').includes(' ');
            const validPhoneNumber = typeof value === 'string' && isValidPhoneNumber(value) && !hasSpaces;
            return isEmptyPhoneNumber || validPhoneNumber || messages.invalid({
                field: valueName
            });
        };
    };
    /** For react-hook-form library. */ const phoneNumberValidation = function phoneNumberValidation(valueName) {
        let { required = false } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return {
            validate: {
                phoneNumber: getPhoneNumberValidator(valueName, required)
            },
            dataAttr: {
                'data-validation': 'phone-number'
            }
        };
    };
    const getUSPhoneNumberValidator = function getUSPhoneNumberValidator() {
        let required = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        return (value)=>{
            const requiredError = getRequiredValidator(required)(value);
            if (requiredError !== true) {
                return requiredError;
            }
            const isEmptyPhoneNumber = !value || value === '';
            const validPhoneNumber = typeof value === 'string' && validUSPhoneRegex.test(value);
            return isEmptyPhoneNumber || validPhoneNumber || messages.invalidUsPhone();
        };
    };
    /** For react-hook-form library. */ const usPhoneNumberValidation = function usPhoneNumberValidation() {
        let { required = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return {
            validate: {
                phoneNumber: getUSPhoneNumberValidator(required)
            },
            dataAttr: {
                'data-validation': 'us-phone-number'
            }
        };
    };
    return {
        getPhoneNumberValidator,
        phoneNumberValidation,
        getUSPhoneNumberValidator,
        usPhoneNumberValidation
    };
};
export const { getPhoneNumberValidator, phoneNumberValidation, getUSPhoneNumberValidator, usPhoneNumberValidation } = makePhoneNumberValidators(englishValidationMessages);
